import { type AxiosInstance } from "axios";
import type { EditNameFormData, Order } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 指定された発注のタスク名を更新する。
 * @param apiClient - axios インスタンス
 * @param id - 発注ID
 * @param data - 更新するタスク名データ
 * @returns 更新後の発注情報
 */
export const PutOrderNameAPI = async (
  apiClient: AxiosInstance,
  id: number,
  data: EditNameFormData
): Promise<Order> => {
  const url = `/dm/orders/${id}/`;

  try {
    const response = await apiClient.put<Order>(url, data);
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
